// extracted by mini-css-extract-plugin
module.exports = {"leadingSection":"styles_leadingSection__qguQ5","footerDescription":"styles_footerDescription__gdA1f","footerDescriptionText":"styles_footerDescriptionText__BjjA8"};